import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
export class Vimeo {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined,

    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init());
    }


    // We could consume the Vimeo API to get the thumbnail, otherwise we could just use the default thumbnail/upload thumbnail
    // async getThumbnail() {
    //     const respo = await fetch(`https://api.vimeo.com/videos/112836958/pictures`)
    //     const data = await respo.json();
    //     console.log(data)
    // }

    showOverlay() {
        this.dom.container.querySelector(".vimeo__video-overlay-container").classList.add("is-visible");
        this.dom.container.querySelector(".vimeo__video-poster").classList.add("--hidden");
        document.querySelector("header").style = `top: -80px`;
        // document.body.classList.add("no-scroll");
    }

    hideOverlay() {
        document.querySelector(".vimeo__video-overlay-container").classList.remove("is-visible");
        document.querySelector(".vimeo__video-poster").classList.remove("--hidden");
        // document.body.classList.remove("no-scroll");
    }


    init() {
        addEvent(this.dom.container.querySelector(".vimeo__video-poster"), "click", () => this.showOverlay());
        addEvent(this.dom.container.querySelector(".vimeo__video-close"), "click", () => this.hideOverlay());
        document.addEventListener("keyup", (e) => {
            if(e.key === "Escape") {
                if(document.querySelector('.vimeo__video-overlay-container.is-visible')) {
                    document.querySelector('.vimeo__video-overlay-container.is-visible').classList.remove("is-visible")
                    this.dom.container.querySelector(".vimeo__video-poster").classList.remove("--hidden");
                }
            }
        })
    }
}
